import { render } from "./ComponentHeader.vue?vue&type=template&id=1324ae1c&scoped=true"
import script from "./ComponentHeader.vue?vue&type=script&lang=js"
export * from "./ComponentHeader.vue?vue&type=script&lang=js"

import "./ComponentHeader.vue?vue&type=style&index=0&id=1324ae1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1324ae1c"]])

export default __exports__